var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.renderOrderPropertyList
    ? _c("div", { staticClass: "order-property-slider mb-3" }, [
        _c(
          "div",
          {
            staticClass: "order-property-slider-inner",
            style: { transform: "translateX(-" + _vm.activeSlide * 100 + "%)" },
          },
          _vm._l(_vm.sortedGroupedProperties, function (propertyGroup, index) {
            return _c(
              "div",
              { key: index, class: { active: index === _vm.activeSlide } },
              [
                _c("order-property-list-group", {
                  key: propertyGroup.id,
                  attrs: {
                    "padding-classes": _vm.paddingClasses,
                    "padding-inline-styles": _vm.paddingInlineStyles,
                    "property-group": propertyGroup,
                  },
                }),
              ],
              1
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm.sortedGroupedProperties.length > 1
          ? _c(
              "div",
              {
                staticClass: "order-property-slider-controls",
                class: _vm.paddingClasses,
                style: _vm.paddingInlineStyles,
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "btn shadow-none",
                    class: {
                      "btn-primary": _vm.activeSlide > 0,
                      "btn-secondary disabled": _vm.activeSlide === 0,
                    },
                    attrs: {
                      tabindex: "0",
                      "data-testing": "order-property-previous-slide",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.slideTo(_vm.activeSlide - 1)
                      },
                    },
                  },
                  [_c("span", { staticClass: "fa fa-chevron-left" })]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "slider-nav" },
                  _vm._l(
                    _vm.sortedGroupedProperties,
                    function (propertyGroup, index) {
                      return _c("span", {
                        directives: [{ name: "tooltip", rawName: "v-tooltip" }],
                        key: index,
                        class: {
                          active: index === _vm.activeSlide,
                          highlight: !_vm.touchedSlides[index],
                          error: propertyGroup.hasError,
                        },
                        attrs: {
                          "data-toggle": "tooltip",
                          "data-placement": "top",
                          title: propertyGroup.group
                            ? propertyGroup.group.names.name
                            : _vm.$translate(
                                "Ceres::Template.singleItemPropertiesWithoutGroup"
                              ),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.slideTo(index)
                          },
                        },
                      })
                    }
                  ),
                  0
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "btn float-right shadow-none",
                    class: {
                      "btn-primary":
                        _vm.activeSlide <
                        _vm.sortedGroupedProperties.length - 1,
                      "btn-secondary disabled":
                        _vm.activeSlide >=
                        _vm.sortedGroupedProperties.length - 1,
                    },
                    attrs: {
                      tabindex: "0",
                      "data-testing": "order-property-next-slide",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.slideTo(_vm.activeSlide + 1)
                      },
                    },
                  },
                  [_c("span", { staticClass: "fa fa-chevron-right" })]
                ),
              ]
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }